import React from 'react'

const ProjectBox = () => {
	return (
		<div className="project-box">
			<img src="../img/projects/server_site.png" alt="" />
			<div className="project-content">
				<h3 className="no-select">Cloud Server Company</h3>
				<p className="no-select">Core Frontend Website</p>
				<a href="https://server-site.netlify.app/" target="_blank" className="btn-project btn">View Project</a>
			</div>
		</div>
	)
}

export default ProjectBox